// eslint-disable max-len
export default {
    ADD_TO_CART: 'カートに追加する',
    ADD_TO_WISHLIST: 'ウィッシュリストに追加する',
    APPLY: '登録する',
    CALL_US: '',
    CANCEL: 'カスタマイズ編集に戻る',
    CHOOSE_OPTION: 'オプションを選択',
    COMPLETED: '完了しました',
    COMPONENTS: 'カスタマイズ箇所',
    COPY: 'URLをコピー',
    COPIED: 'コピーしました',
    CUSTOMER_SERVICE: 'お困りですか？',
    DETAILS: '詳細',
    DIFFERENT_SIZE: '左右で異なるサイズを希望する',
    DONE_FOR_NOW: 'カスタマイズを終了しますか？',
    EMAIL: 'Eメール',
    EMAIL_DESIGN: 'メールで送る',
    EMAIL_INVALID: 'メールアドレスを正しく入力してください。',
    EMAIL_SENT: 'カスタマイズしたマイジョイズへのリンクが送信されました。',
    EMAIL_SUMMARY: 'MyJoys: Eメール概要',
    ENTER_EMBROIDERY: '文字を記入',
    HELP: 'ヘルプ',
    HOURS: '',
    INVALID_ERROR: '無効なフレーズです。',
    MAKE_A_SELECTION: '続けて選択する',
    MAX_LENGTH_6: '標準フォントは6文字まで',
    MAX_LENGTH_3: '手書き風フォントは3文字まで',
    MENS: 'メンズ',
    MESSAGE: 'メッセージ',
    MESSAGE_US: 'お問い合わせ',
    NEED_HELP: '助けが必要ですか？',
    NONE_SELECTED: '未選択',
    OK: 'OK',
    PERSONALIZATION_POLICY: 'パーソナライゼーション ポリシー',
    PHONE_NUMBER: '',
    PHONE_NUMBER_FORMATTED: '',
    PRINT: '印刷する',
    RECIPIENT_NAME: '受取人 お名前',
    RECIPIENT_EMAIL: '受取人 Eメール',
    REQUIRED: 'このフィールドは必須項目です。',
    RESET: 'リセット',
    RESET_CONFIRM: 'すべての選択をリセットしますか？',
    RESET_CONFIRM_COPY: '続行すると、すべての選択がリセットされ、デザインは最初からやり直しになります。',

    SAVE: '保存する',
    SAVE_EXIT: 'デザインを保存する',

    SELECT_SIZE: 'サイズ',
    SELECT_WIDTH: 'ウィズ（幅）',
    LEFT_SHOE_SIZE: '左足',
    RIGHT_SHOE_SIZE: '右足',

    SEND_COPY: 'メールのコピーも送る。',
    SHARE: 'シェア',
    SHARE_DESIGN: '友だちにシェア',
    SIZE_GUIDE: 'サイズガイド',
    SUBMIT: '送信する',
    UNDO: '一つ戻す',
    VIEW_ALL: 'すべて見る',
    WEVE_GOT_YOU: 'このページを離れても、あなたが選択したMyJoysのパターンを保存することができます。',
    WOMENS: 'ウィメンズ',
    YOUR_NAME: '名前',
    YOUR_EMAIL: 'Eメール',
    BACKORDERED: 'サイズは入荷待ちです、{date} 以降に注文が可能です',
    INSTANCE_ERROR_HEADER: '選択を保存中にエラーが発生しました',
    INSTANCE_ERROR_BODY: '現在、選択内容を保存できません。しばらくしてから再度お試しください。',
    UPDATE_CART: 'カートを更新',
    PERSONALIZE_CHOOSE_OPTION: 'オプションを選択',
    PERSONALIZE_SAME_LEFT: '左足と同じ',
    PERSONALIZE_SAME_RIGHT: '右足と同じ',
    PERSONALIZE_NONE: 'なし',
    PERSONALIZE_LOGO: 'ロゴ',
    PERSONALIZE_MONOGRAM: '文字',
    MONOGRAM_COLOR: 'カラー',
    NOT_AVAILABLE_BODY: 'この商品は現在アクセスできません。',
    NOT_AVAILABLE_HEADER: '利用できません。',
};
